// source: pbtypes/gen/cellular_sim_configs/sim_config.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_cellular_sim_configs_access_mode_pb = require('../../../pbtypes/gen/cellular_sim_configs/access_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_cellular_sim_configs_access_mode_pb);
var pbtypes_gen_cellular_sim_configs_auth_type_pb = require('../../../pbtypes/gen/cellular_sim_configs/auth_type_pb.js');
goog.object.extend(proto, pbtypes_gen_cellular_sim_configs_auth_type_pb);
var pbtypes_gen_cellular_sim_configs_band_pb = require('../../../pbtypes/gen/cellular_sim_configs/band_pb.js');
goog.object.extend(proto, pbtypes_gen_cellular_sim_configs_band_pb);
var pbtypes_gen_cellular_sim_configs_config_entry_pb = require('../../../pbtypes/gen/cellular_sim_configs/config_entry_pb.js');
goog.object.extend(proto, pbtypes_gen_cellular_sim_configs_config_entry_pb);
var pbtypes_gen_cellular_sim_configs_fn920_config_pb = require('../../../pbtypes/gen/cellular_sim_configs/fn920_config_pb.js');
goog.object.extend(proto, pbtypes_gen_cellular_sim_configs_fn920_config_pb);
var pbtypes_gen_cellular_sim_configs_fn980_config_pb = require('../../../pbtypes/gen/cellular_sim_configs/fn980_config_pb.js');
goog.object.extend(proto, pbtypes_gen_cellular_sim_configs_fn980_config_pb);
var pbtypes_gen_cellular_sim_configs_fn990_config_pb = require('../../../pbtypes/gen/cellular_sim_configs/fn990_config_pb.js');
goog.object.extend(proto, pbtypes_gen_cellular_sim_configs_fn990_config_pb);
var pbtypes_gen_cellular_sim_configs_ip_mode_pb = require('../../../pbtypes/gen/cellular_sim_configs/ip_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_cellular_sim_configs_ip_mode_pb);
var pbtypes_gen_cellular_sim_configs_wds_mode_pb = require('../../../pbtypes/gen/cellular_sim_configs/wds_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_cellular_sim_configs_wds_mode_pb);
goog.exportSymbol('proto.cellular_sim_configs.SimConfig', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cellular_sim_configs.SimConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cellular_sim_configs.SimConfig.repeatedFields_, null);
};
goog.inherits(proto.cellular_sim_configs.SimConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cellular_sim_configs.SimConfig.displayName = 'proto.cellular_sim_configs.SimConfig';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cellular_sim_configs.SimConfig.repeatedFields_ = [22];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cellular_sim_configs.SimConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.cellular_sim_configs.SimConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cellular_sim_configs.SimConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cellular_sim_configs.SimConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
apn: jspb.Message.getFieldWithDefault(msg, 1, ""),
enabledBands: (f = msg.getEnabledBands()) && pbtypes_gen_cellular_sim_configs_band_pb.Band.toObject(includeInstance, f),
username: jspb.Message.getFieldWithDefault(msg, 3, ""),
password: jspb.Message.getFieldWithDefault(msg, 4, ""),
authType: jspb.Message.getFieldWithDefault(msg, 5, 0),
wdsMode: jspb.Message.getFieldWithDefault(msg, 6, 0),
ipMode: jspb.Message.getFieldWithDefault(msg, 7, 0),
minBitrate: jspb.Message.getFieldWithDefault(msg, 8, 0),
maxBitrate: jspb.Message.getFieldWithDefault(msg, 9, 0),
minLatency: jspb.Message.getFieldWithDefault(msg, 10, 0),
maxLatency: jspb.Message.getFieldWithDefault(msg, 11, 0),
fn980Config: (f = msg.getFn980Config()) && pbtypes_gen_cellular_sim_configs_fn980_config_pb.Fn980Config.toObject(includeInstance, f),
fn990Config: (f = msg.getFn990Config()) && pbtypes_gen_cellular_sim_configs_fn990_config_pb.Fn990Config.toObject(includeInstance, f),
fn990ExtConfig: (f = msg.getFn990ExtConfig()) && pbtypes_gen_cellular_sim_configs_fn990_config_pb.Fn990Config.toObject(includeInstance, f),
fn920ExtConfig: (f = msg.getFn920ExtConfig()) && pbtypes_gen_cellular_sim_configs_fn920_config_pb.Fn920Config.toObject(includeInstance, f),
fn990ControllerConfig: (f = msg.getFn990ControllerConfig()) && pbtypes_gen_cellular_sim_configs_fn990_config_pb.Fn990Config.toObject(includeInstance, f),
fn990R10Config: (f = msg.getFn990R10Config()) && pbtypes_gen_cellular_sim_configs_fn990_config_pb.Fn990Config.toObject(includeInstance, f),
blocked: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
carrier: jspb.Message.getFieldWithDefault(msg, 15, ""),
profileIndex: jspb.Message.getFieldWithDefault(msg, 16, 0),
requestedAccessMode: (f = msg.getRequestedAccessMode()) && pbtypes_gen_cellular_sim_configs_access_mode_pb.AccessMode.toObject(includeInstance, f),
kvList: jspb.Message.toObjectList(msg.getKvList(),
    pbtypes_gen_cellular_sim_configs_config_entry_pb.ConfigEntry.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cellular_sim_configs.SimConfig}
 */
proto.cellular_sim_configs.SimConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cellular_sim_configs.SimConfig;
  return proto.cellular_sim_configs.SimConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cellular_sim_configs.SimConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cellular_sim_configs.SimConfig}
 */
proto.cellular_sim_configs.SimConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setApn(value);
      break;
    case 2:
      var value = new pbtypes_gen_cellular_sim_configs_band_pb.Band;
      reader.readMessage(value,pbtypes_gen_cellular_sim_configs_band_pb.Band.deserializeBinaryFromReader);
      msg.setEnabledBands(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUsername(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPassword(value);
      break;
    case 5:
      var value = /** @type {!proto.cellular_sim_configs.AuthType.Enum} */ (reader.readEnum());
      msg.setAuthType(value);
      break;
    case 6:
      var value = /** @type {!proto.cellular_sim_configs.WdsMode.Enum} */ (reader.readEnum());
      msg.setWdsMode(value);
      break;
    case 7:
      var value = /** @type {!proto.cellular_sim_configs.IpMode.Enum} */ (reader.readEnum());
      msg.setIpMode(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setMinBitrate(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setMaxBitrate(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setMinLatency(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setMaxLatency(value);
      break;
    case 12:
      var value = new pbtypes_gen_cellular_sim_configs_fn980_config_pb.Fn980Config;
      reader.readMessage(value,pbtypes_gen_cellular_sim_configs_fn980_config_pb.Fn980Config.deserializeBinaryFromReader);
      msg.setFn980Config(value);
      break;
    case 13:
      var value = new pbtypes_gen_cellular_sim_configs_fn990_config_pb.Fn990Config;
      reader.readMessage(value,pbtypes_gen_cellular_sim_configs_fn990_config_pb.Fn990Config.deserializeBinaryFromReader);
      msg.setFn990Config(value);
      break;
    case 18:
      var value = new pbtypes_gen_cellular_sim_configs_fn990_config_pb.Fn990Config;
      reader.readMessage(value,pbtypes_gen_cellular_sim_configs_fn990_config_pb.Fn990Config.deserializeBinaryFromReader);
      msg.setFn990ExtConfig(value);
      break;
    case 19:
      var value = new pbtypes_gen_cellular_sim_configs_fn920_config_pb.Fn920Config;
      reader.readMessage(value,pbtypes_gen_cellular_sim_configs_fn920_config_pb.Fn920Config.deserializeBinaryFromReader);
      msg.setFn920ExtConfig(value);
      break;
    case 20:
      var value = new pbtypes_gen_cellular_sim_configs_fn990_config_pb.Fn990Config;
      reader.readMessage(value,pbtypes_gen_cellular_sim_configs_fn990_config_pb.Fn990Config.deserializeBinaryFromReader);
      msg.setFn990ControllerConfig(value);
      break;
    case 21:
      var value = new pbtypes_gen_cellular_sim_configs_fn990_config_pb.Fn990Config;
      reader.readMessage(value,pbtypes_gen_cellular_sim_configs_fn990_config_pb.Fn990Config.deserializeBinaryFromReader);
      msg.setFn990R10Config(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBlocked(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCarrier(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setProfileIndex(value);
      break;
    case 17:
      var value = new pbtypes_gen_cellular_sim_configs_access_mode_pb.AccessMode;
      reader.readMessage(value,pbtypes_gen_cellular_sim_configs_access_mode_pb.AccessMode.deserializeBinaryFromReader);
      msg.setRequestedAccessMode(value);
      break;
    case 22:
      var value = new pbtypes_gen_cellular_sim_configs_config_entry_pb.ConfigEntry;
      reader.readMessage(value,pbtypes_gen_cellular_sim_configs_config_entry_pb.ConfigEntry.deserializeBinaryFromReader);
      msg.addKv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cellular_sim_configs.SimConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cellular_sim_configs.SimConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cellular_sim_configs.SimConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cellular_sim_configs.SimConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApn();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEnabledBands();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_cellular_sim_configs_band_pb.Band.serializeBinaryToWriter
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAuthType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getWdsMode();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getIpMode();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getMinBitrate();
  if (f !== 0) {
    writer.writeSint64(
      8,
      f
    );
  }
  f = message.getMaxBitrate();
  if (f !== 0) {
    writer.writeSint64(
      9,
      f
    );
  }
  f = message.getMinLatency();
  if (f !== 0) {
    writer.writeSint64(
      10,
      f
    );
  }
  f = message.getMaxLatency();
  if (f !== 0) {
    writer.writeSint64(
      11,
      f
    );
  }
  f = message.getFn980Config();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      pbtypes_gen_cellular_sim_configs_fn980_config_pb.Fn980Config.serializeBinaryToWriter
    );
  }
  f = message.getFn990Config();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      pbtypes_gen_cellular_sim_configs_fn990_config_pb.Fn990Config.serializeBinaryToWriter
    );
  }
  f = message.getFn990ExtConfig();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      pbtypes_gen_cellular_sim_configs_fn990_config_pb.Fn990Config.serializeBinaryToWriter
    );
  }
  f = message.getFn920ExtConfig();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      pbtypes_gen_cellular_sim_configs_fn920_config_pb.Fn920Config.serializeBinaryToWriter
    );
  }
  f = message.getFn990ControllerConfig();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      pbtypes_gen_cellular_sim_configs_fn990_config_pb.Fn990Config.serializeBinaryToWriter
    );
  }
  f = message.getFn990R10Config();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      pbtypes_gen_cellular_sim_configs_fn990_config_pb.Fn990Config.serializeBinaryToWriter
    );
  }
  f = message.getBlocked();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getCarrier();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getProfileIndex();
  if (f !== 0) {
    writer.writeUint32(
      16,
      f
    );
  }
  f = message.getRequestedAccessMode();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      pbtypes_gen_cellular_sim_configs_access_mode_pb.AccessMode.serializeBinaryToWriter
    );
  }
  f = message.getKvList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      22,
      f,
      pbtypes_gen_cellular_sim_configs_config_entry_pb.ConfigEntry.serializeBinaryToWriter
    );
  }
};


/**
 * optional string apn = 1;
 * @return {string}
 */
proto.cellular_sim_configs.SimConfig.prototype.getApn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.setApn = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Band enabled_bands = 2;
 * @return {?proto.cellular_sim_configs.Band}
 */
proto.cellular_sim_configs.SimConfig.prototype.getEnabledBands = function() {
  return /** @type{?proto.cellular_sim_configs.Band} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_cellular_sim_configs_band_pb.Band, 2));
};


/**
 * @param {?proto.cellular_sim_configs.Band|undefined} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
*/
proto.cellular_sim_configs.SimConfig.prototype.setEnabledBands = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.clearEnabledBands = function() {
  return this.setEnabledBands(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cellular_sim_configs.SimConfig.prototype.hasEnabledBands = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string username = 3;
 * @return {string}
 */
proto.cellular_sim_configs.SimConfig.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string password = 4;
 * @return {string}
 */
proto.cellular_sim_configs.SimConfig.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional AuthType.Enum auth_type = 5;
 * @return {!proto.cellular_sim_configs.AuthType.Enum}
 */
proto.cellular_sim_configs.SimConfig.prototype.getAuthType = function() {
  return /** @type {!proto.cellular_sim_configs.AuthType.Enum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.cellular_sim_configs.AuthType.Enum} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.setAuthType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional WdsMode.Enum wds_mode = 6;
 * @return {!proto.cellular_sim_configs.WdsMode.Enum}
 */
proto.cellular_sim_configs.SimConfig.prototype.getWdsMode = function() {
  return /** @type {!proto.cellular_sim_configs.WdsMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.cellular_sim_configs.WdsMode.Enum} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.setWdsMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional IpMode.Enum ip_mode = 7;
 * @return {!proto.cellular_sim_configs.IpMode.Enum}
 */
proto.cellular_sim_configs.SimConfig.prototype.getIpMode = function() {
  return /** @type {!proto.cellular_sim_configs.IpMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.cellular_sim_configs.IpMode.Enum} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.setIpMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional sint64 min_bitrate = 8;
 * @return {number}
 */
proto.cellular_sim_configs.SimConfig.prototype.getMinBitrate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.setMinBitrate = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional sint64 max_bitrate = 9;
 * @return {number}
 */
proto.cellular_sim_configs.SimConfig.prototype.getMaxBitrate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.setMaxBitrate = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional sint64 min_latency = 10;
 * @return {number}
 */
proto.cellular_sim_configs.SimConfig.prototype.getMinLatency = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.setMinLatency = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional sint64 max_latency = 11;
 * @return {number}
 */
proto.cellular_sim_configs.SimConfig.prototype.getMaxLatency = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.setMaxLatency = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional Fn980Config fn980_config = 12;
 * @return {?proto.cellular_sim_configs.Fn980Config}
 */
proto.cellular_sim_configs.SimConfig.prototype.getFn980Config = function() {
  return /** @type{?proto.cellular_sim_configs.Fn980Config} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_cellular_sim_configs_fn980_config_pb.Fn980Config, 12));
};


/**
 * @param {?proto.cellular_sim_configs.Fn980Config|undefined} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
*/
proto.cellular_sim_configs.SimConfig.prototype.setFn980Config = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.clearFn980Config = function() {
  return this.setFn980Config(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cellular_sim_configs.SimConfig.prototype.hasFn980Config = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional Fn990Config fn990_config = 13;
 * @return {?proto.cellular_sim_configs.Fn990Config}
 */
proto.cellular_sim_configs.SimConfig.prototype.getFn990Config = function() {
  return /** @type{?proto.cellular_sim_configs.Fn990Config} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_cellular_sim_configs_fn990_config_pb.Fn990Config, 13));
};


/**
 * @param {?proto.cellular_sim_configs.Fn990Config|undefined} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
*/
proto.cellular_sim_configs.SimConfig.prototype.setFn990Config = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.clearFn990Config = function() {
  return this.setFn990Config(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cellular_sim_configs.SimConfig.prototype.hasFn990Config = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional Fn990Config fn990_ext_config = 18;
 * @return {?proto.cellular_sim_configs.Fn990Config}
 */
proto.cellular_sim_configs.SimConfig.prototype.getFn990ExtConfig = function() {
  return /** @type{?proto.cellular_sim_configs.Fn990Config} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_cellular_sim_configs_fn990_config_pb.Fn990Config, 18));
};


/**
 * @param {?proto.cellular_sim_configs.Fn990Config|undefined} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
*/
proto.cellular_sim_configs.SimConfig.prototype.setFn990ExtConfig = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.clearFn990ExtConfig = function() {
  return this.setFn990ExtConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cellular_sim_configs.SimConfig.prototype.hasFn990ExtConfig = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional Fn920Config fn920_ext_config = 19;
 * @return {?proto.cellular_sim_configs.Fn920Config}
 */
proto.cellular_sim_configs.SimConfig.prototype.getFn920ExtConfig = function() {
  return /** @type{?proto.cellular_sim_configs.Fn920Config} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_cellular_sim_configs_fn920_config_pb.Fn920Config, 19));
};


/**
 * @param {?proto.cellular_sim_configs.Fn920Config|undefined} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
*/
proto.cellular_sim_configs.SimConfig.prototype.setFn920ExtConfig = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.clearFn920ExtConfig = function() {
  return this.setFn920ExtConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cellular_sim_configs.SimConfig.prototype.hasFn920ExtConfig = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional Fn990Config fn990_controller_config = 20;
 * @return {?proto.cellular_sim_configs.Fn990Config}
 */
proto.cellular_sim_configs.SimConfig.prototype.getFn990ControllerConfig = function() {
  return /** @type{?proto.cellular_sim_configs.Fn990Config} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_cellular_sim_configs_fn990_config_pb.Fn990Config, 20));
};


/**
 * @param {?proto.cellular_sim_configs.Fn990Config|undefined} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
*/
proto.cellular_sim_configs.SimConfig.prototype.setFn990ControllerConfig = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.clearFn990ControllerConfig = function() {
  return this.setFn990ControllerConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cellular_sim_configs.SimConfig.prototype.hasFn990ControllerConfig = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional Fn990Config fn990_r10_config = 21;
 * @return {?proto.cellular_sim_configs.Fn990Config}
 */
proto.cellular_sim_configs.SimConfig.prototype.getFn990R10Config = function() {
  return /** @type{?proto.cellular_sim_configs.Fn990Config} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_cellular_sim_configs_fn990_config_pb.Fn990Config, 21));
};


/**
 * @param {?proto.cellular_sim_configs.Fn990Config|undefined} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
*/
proto.cellular_sim_configs.SimConfig.prototype.setFn990R10Config = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.clearFn990R10Config = function() {
  return this.setFn990R10Config(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cellular_sim_configs.SimConfig.prototype.hasFn990R10Config = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional bool blocked = 14;
 * @return {boolean}
 */
proto.cellular_sim_configs.SimConfig.prototype.getBlocked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.setBlocked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional string carrier = 15;
 * @return {string}
 */
proto.cellular_sim_configs.SimConfig.prototype.getCarrier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.setCarrier = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional uint32 profile_index = 16;
 * @return {number}
 */
proto.cellular_sim_configs.SimConfig.prototype.getProfileIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.setProfileIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional AccessMode requested_access_mode = 17;
 * @return {?proto.cellular_sim_configs.AccessMode}
 */
proto.cellular_sim_configs.SimConfig.prototype.getRequestedAccessMode = function() {
  return /** @type{?proto.cellular_sim_configs.AccessMode} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_cellular_sim_configs_access_mode_pb.AccessMode, 17));
};


/**
 * @param {?proto.cellular_sim_configs.AccessMode|undefined} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
*/
proto.cellular_sim_configs.SimConfig.prototype.setRequestedAccessMode = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.clearRequestedAccessMode = function() {
  return this.setRequestedAccessMode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cellular_sim_configs.SimConfig.prototype.hasRequestedAccessMode = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * repeated ConfigEntry kv = 22;
 * @return {!Array<!proto.cellular_sim_configs.ConfigEntry>}
 */
proto.cellular_sim_configs.SimConfig.prototype.getKvList = function() {
  return /** @type{!Array<!proto.cellular_sim_configs.ConfigEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_cellular_sim_configs_config_entry_pb.ConfigEntry, 22));
};


/**
 * @param {!Array<!proto.cellular_sim_configs.ConfigEntry>} value
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
*/
proto.cellular_sim_configs.SimConfig.prototype.setKvList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 22, value);
};


/**
 * @param {!proto.cellular_sim_configs.ConfigEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cellular_sim_configs.ConfigEntry}
 */
proto.cellular_sim_configs.SimConfig.prototype.addKv = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 22, opt_value, proto.cellular_sim_configs.ConfigEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cellular_sim_configs.SimConfig} returns this
 */
proto.cellular_sim_configs.SimConfig.prototype.clearKvList = function() {
  return this.setKvList([]);
};


goog.object.extend(exports, proto.cellular_sim_configs);
